/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Body for starting the cohort in_exam segment with an explicit admission set.
 */
export interface OralExamStartCohortRequest {
  admittedBookingIds: string[];
  partialStart?: boolean;
}
